import { render, staticRenderFns } from "./ChatSection.vue?vue&type=template&id=9de77b18&scoped=true"
import script from "./ChatSection.vue?vue&type=script&lang=js"
export * from "./ChatSection.vue?vue&type=script&lang=js"
import style0 from "./ChatSection.vue?vue&type=style&index=0&id=9de77b18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de77b18",
  null
  
)

export default component.exports